import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { debounce } from 'lodash';
/**
 * WordPress dependencies
 */

import { Component } from '@wordpress/element';
import { speak as _speak } from '@wordpress/a11y';
import { createHigherOrderComponent } from '@wordpress/compose';
/**
 * A Higher Order Component used to be provide a unique instance ID by
 * component.
 *
 * @param {WPElement} WrappedComponent  The wrapped component.
 *
 * @return {Component} Component with an instanceId prop.
 */

export default createHigherOrderComponent(function (WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
        _this.debouncedSpeak = debounce(_this.speak.bind(_assertThisInitialized(_this)), 500);
        return _this;
      }

      _createClass(_class, [{
        key: "speak",
        value: function speak(message) {
          var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'polite';

          _speak(message, type);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.debouncedSpeak.cancel();
        }
      }, {
        key: "render",
        value: function render() {
          return createElement(WrappedComponent, _extends({}, this.props, {
            speak: this.speak,
            debouncedSpeak: this.debouncedSpeak
          }));
        }
      }]);

      return _class;
    }(Component)
  );
}, 'withSpokenMessages');
//# sourceMappingURL=index.js.map